// Small formatting helpers shared across Finance UI.
export const CURRENCY_SYMBOL = { USD: "$", EUR: "€", CDF: "FC", ZAR: "R" };

export const fmtMoney = (v, currency = "USD") => {
  const n = Number(v || 0);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const s = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(abs);
  return `${sign}${s} ${currency || "USD"}`;
};

export const fmtCompact = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (Math.abs(n) >= 1_000) return (n / 1_000).toFixed(1) + "k";
  return String(n);
};

export const STAGES = [
  { key: "nouveau", label: "Nouveau" },
  { key: "contacte", label: "Contacté" },
  { key: "rdv", label: "Rendez-vous" },
  { key: "visite", label: "Visité" },
  { key: "offre", label: "Offre" },
  { key: "negociation", label: "Négociation" },
  { key: "paiement", label: "Paiement" },
  { key: "client", label: "Client" },
  { key: "perdu", label: "Perdu" },
];

export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));

export const EXPENSE_CATEGORIES = [
  { value: "transport", label: "Transport" },
  { value: "carburant", label: "Carburant" },
  { value: "publicite", label: "Publicité" },
  { value: "photo", label: "Photographie" },
  { value: "video", label: "Vidéo" },
  { value: "drone", label: "Drone" },
  { value: "communication", label: "Communication" },
  { value: "admin", label: "Frais administratifs" },
  { value: "juridique", label: "Frais juridiques" },
  { value: "impression", label: "Impression" },
  { value: "commission_externe", label: "Commission externe" },
  { value: "autre", label: "Autre" },
];

export const PAYMENT_METHODS = [
  { value: "espece", label: "Espèces" },
  { value: "virement", label: "Virement bancaire" },
  { value: "mobile_money", label: "Mobile Money" },
  { value: "carte", label: "Carte" },
  { value: "cheque", label: "Chèque" },
  { value: "autre", label: "Autre" },
];
